import { inject, injectable } from "inversify";
import { OperationDetailsModelFS } from "@/extensions/models/history/operationDetailsModelFS";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import IErrorService from "fs-pb-vue2/services/error/IErrorService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import CardStatementService from "fs-pb-vue2/services/history/CardStatementService";
import { OperationsHistoryApi } from "fs-pb-vue2/services/api/OperationsHistoryApi";

@injectable()
/** Сервис выписки по счету */
export default class CardStatementServiceFS
  extends CardStatementService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) { super(alertService, errorService) }

  public async getOperationDetails(
    operation: any
  ): Promise<OperationDetailsModelFS> {
    try {
      // const operationDetail = new OperationDetailsModel(operation, null, null, operation.modalDetails);
      const requestData = await OperationsHistoryApi.getOperationAsync(
        0,
        operation.ReferenceId
      );
      const respondentCode = parseInt(requestData.respondentCode);
      const operationDetail = new OperationDetailsModelFS(operation, requestData, null, operation.modalDetails);

      if (!isNaN(respondentCode)) {
        operationDetail.RespondentData = await OperationsHistoryApi.getRespondentAsync(
          respondentCode
        );
      }
      // operationDetail.RequestData?.details.forEach(
      //   (d: DeclarationPropertyValueData) => {
      //     d.Value = replaceCurrencySymb(d.Value);
      //   }
      // );

      // if (operationDetail.RequestData?.details)
      //   operationDetail.Details = operationDetail.RequestData?.details;
       
      return operationDetail;
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
      throw e;
    }
  }
}
